<template functional>
  <component
    :is="props.component"
    class="py-3"
    :class="{ 'bg-light': props.alternate }">
    <slot></slot>
  </component>
</template>
<script>
export default {
  functional: true,

  props: {
    alternate: {
      type: Boolean,
      default: false
    },

    component: {
      default: 'b-row'
    }
  }
};
</script>

